export default __webpack_public_path__ + "static/media/Payout_active.2eab1579.svg";